import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { EventsService } from 'app/shared/service/events.service';
import { debounceTime, map, merge, mergeMap, retry, switchMap, tap } from 'rxjs';
import { userUpdated } from '../auth/auth.actions';
import {
    changeReadState,
    hideNotification,
    loadNotifications,
    requestChangeReadState,
    requestHideNotification,
    requestRecurrenceMonths,
    requestSendEmails,
    setNotifications,
} from './notifications.actions';
import { NotificationsApi } from './notifications.api';


@Injectable()
export class NotificationsEffects {

    private actions = inject(Actions);

    private api = inject(NotificationsApi);

    private es = inject(EventsService);

    loadNotifications = createEffect(() =>
        this.actions.pipe(
            ofType(loadNotifications),
            switchMap(() => this.api.fetchNotifications()),
            map(notifications => setNotifications({ notifications })),
            retry({ delay: 5000 })
        )
    );

    changeNotificationsReadState = createEffect(() =>
        this.actions.pipe(
            ofType(requestChangeReadState),
            mergeMap(action => this.api.changeReadState(action.notifications)),
            map(({ notifications }) => changeReadState({ notifications }))
        )
    );

    hideNotification = createEffect(() =>
        this.actions.pipe(
            ofType(requestHideNotification),
            mergeMap(action => this.api.hideNotification(action.notificationId)),
            map(({ notificationId }) => hideNotification({ notificationId }))
        )
    );

    changePreferences = createEffect(() =>
        merge(
            this.actions.pipe(
                ofType(requestSendEmails),
                mergeMap(({ enabled }) => this.api.setPreferences({ sendNotificationsEmail: enabled }))
            ),
            this.actions.pipe(
                ofType(requestRecurrenceMonths),
                debounceTime(200),
                switchMap(({ months }) => this.api.setPreferences({ notificationsRecurrence: months }))
            )
        ).pipe(
            map(({ sendNotificationsEmail, notificationsRecurrence }) =>
                userUpdated({ user: { sendNotificationsEmail, notificationsRecurrence } })
            ),
            tap(_ => this.es.formSavedSubject.next())
        )
    );
}
